import moment from "moment";
import { createCrudActions } from '../utils/crudGenerator';

const formatReferrals = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
        verifiedAt: item.verifiedAt && moment(item.verifiedAt),
        usedAt: item.usedAt && moment(item.usedAt),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchReferrals,
    create: createReferral,
    update: updateReferral,
    delete: deleteReferrals
} = createCrudActions('REFERRAL', "Remisión", formatReferrals);
